// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7312) return "static/chunks/7312-6b64983df7af8e23.js";
	if (chunkId === 1133) return "static/chunks/1133-39bf7bbe0d7b94c2.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4288":"ae1e8a671827b06b","6141":"efa834b054f7ddaa","8875":"c46e4ae7af2eab53","9057":"7e2e7cd11fe396a5"}[chunkId] + ".js";
};